import styles from "./Button.module.css"
function Button(){
    return <button className={styles.feedbackButton}>Give Feedback</button>
}
export default Button
